/** Canonical startup document id for catalog cards, tracking, and viewed badges. */
export function resolveStartupId(startup: { id?: string; userId?: string }): string | undefined {
  return startup.id || startup.userId;
}
